const SHOP_BASE = "/shopping-widget";

const normalizeShopTarget = (targetUrl) => {
  if (
    targetUrl === "/shop" ||
    targetUrl.startsWith("/shop/") ||
    targetUrl.startsWith("/shop?")
  ) {
    return SHOP_BASE + targetUrl.slice("/shop".length);
  }
  return targetUrl;
};

export const safeNavigate = (history, targetUrl, currentPath) => {
  const normalizedTarget = normalizeShopTarget(targetUrl);
  const isInShop = currentPath.startsWith(SHOP_BASE);
  const isGoingToShop =
    normalizedTarget.startsWith(SHOP_BASE) || targetUrl === "/shop";

  // Already inside the shop widget and navigating to shop again — reload the
  // current page so the widget's internal router does not append segments.
  if (isInShop && isGoingToShop) {
    window.location.href = currentPath;
    return;
  }

  // Leaving the shop widget — full reload to tear down its internal router.
  if (isInShop && !isGoingToShop) {
    window.location.href = normalizedTarget;
    return;
  }

  history.push(normalizedTarget);
};